import { useEffect, useState } from 'react';
import lineApi from '../../api/line';
import { LinearProgress } from '../../tailwindcomponents';
import { FlightSchedule } from '../../types/line';
import FlightScheduleComponent from '../../components/Line/FlightScheduleComponent';

function FlightScheduleView() {
    const [flights, setFlights] = useState<Array<FlightSchedule>>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        lineApi.getFlightSchedule().then(res => {
            setFlights(res.data);
            setLoading(false);
        });
    }, []);

    return (
        <div>
            {loading && (
                <div>
                    <LinearProgress />
                </div>
            )}
            <FlightScheduleComponent flights={flights} isMonitor={true} />
        </div>
    );
}

export default FlightScheduleView;